import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

import { AdminCrmRoutes } from './subapps/crm/routes';
import { AdminIamRoutes } from './subapps/iam/routes';
import { AdminIntegrationsRoutes } from './subapps/integrations/routes';
import { AdminSalesRoutes } from './subapps/sales/routes';
import { AdminSuiteRoutes } from './subapps/suite/routes';
import { AdminTalkRoutes } from './subapps/talk/routes';
import Welcome from './welcome.vue';

export const AdminRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: Welcome,
        meta: { admin: true }
    },
    {
        // The tenant side of an MSP relationship, reached ONLY by a link an MSP hands out
        // (see mspInviteUrl in modules/msp) — deliberately absent from admin's nav.ts, so
        // nothing in the product links here. `admin: true` is the real gate: the server
        // requires a native tenant administrator of this tenant.
        path: 'msp-attach',
        component: wrapRuntimeImport(() => import('./msp-attach.vue')),
        meta: { admin: true, subAppName: 'MSP Attachment' }
    },
    {
        path: 'iam',
        component: wrapRuntimeImport(() => import('./subapps/iam/iam.vue')),
        meta: { admin: true, subAppName: 'Identity & Access' },
        children: AdminIamRoutes
    },
    {
        path: 'suite',
        component: wrapRuntimeImport(() => import('./subapps/suite/suite.vue')),
        meta: { admin: true, subAppName: 'General' },
        children: AdminSuiteRoutes
    },
    {
        path: 'integrations',
        component: wrapRuntimeImport(() => import('./subapps/integrations/integrations.vue')),
        meta: { admin: true, subAppName: 'Integrations' },
        children: AdminIntegrationsRoutes
    },
    {
        path: 'crm',
        component: wrapRuntimeImport(() => import('./subapps/crm/crm.vue')),
        meta: { admin: true, subAppName: 'ZynoCRM' },
        children: AdminCrmRoutes
    },
    {
        path: 'sales',
        component: wrapRuntimeImport(() => import('./subapps/sales/sales.vue')),
        meta: { admin: true, subAppName: 'ZynoSales' },
        children: AdminSalesRoutes
    },
    {
        path: 'talk',
        component: wrapRuntimeImport(() => import('./subapps/talk/talk.vue')),
        meta: { admin: true, subAppName: 'ZynoTalk' },
        children: AdminTalkRoutes
    }
];
